import React from 'react';
import { Users, Clock, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const standards = [
  {
    icon: Users,
    name: 'standards.team.title',
    description: 'standards.team.description'
  },
  {
    icon: Clock,
    name: 'standards.reliability.title',
    description: 'standards.reliability.description'
  },
  {
    icon: Sparkles,
    name: 'standards.quality.title',
    description: 'standards.quality.description'
  }
];

export function Certifications() {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            {t('standards.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-300">
            {t('standards.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {standards.map(({ icon: Icon, name, description }) => (
            <div
              key={name}
              className="text-center"
            >
              <Icon className="mx-auto h-12 w-12 text-blue-400" />
              <h3 className="mt-4 text-xl font-semibold text-white">{t(name)}</h3>
              <p className="mt-2 text-gray-400">{t(description)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}